<template>
  <modal-template
    ref="modal"
    modal-size="lg"
    :title="title"
    type-modal="edit_representative_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="save()">
        <d-form-row class="form-group">
          <d-col cols="6">
            <label>Name</label>
            <d-input v-model="model.name" class="form-control" />
          </d-col>
          <d-col cols="6">
            <label>E-mail</label>
            <d-input v-model="model.email" class="form-control" />
          </d-col>
        </d-form-row>
        <d-form-row class="form-group">
          <d-col cols="6">
            <label>Telefone</label>
            <input-phone
              id="feTelefone"
              placeholder="Telefone"
              :model.sync="model.phone"
            ></input-phone>
          </d-col>
          <!-- <d-col cols="6">
            <label>Monitorado por: <small>equipe comercial</small></label>
            <d-select v-model="model.commercial.id" class="form-control" >
              <option :value="commercial.id" v-for="commercial in commercials" :key="commercial.id">{{ commercial.name }}</option>
            </d-select>
          </d-col> -->
        </d-form-row>
        <div class="w-100" v-if="model.id">
          <d-row class="row-table">
            <d-col class="col-table">
              <table class="table-sync table mb-0 table-striped">
                <thead class="bg-light">
                  <tr>
                    <th scope="col" class="border-0">Lojas Relacionadas</th>
                  </tr>
                  <tr>
                    <td scope="col" class="border-0 px-0">
                      <div class="d-flex">
                        <d-input v-model="filters.attached.search" placeholder="Pesquisar" class="form-control" />
                      </div>
                    </td>
                  </tr>
                </thead>
                <tbody class="draggable-item" >
                  <tr
                    v-for="(row, index) in attachedResellersList"
                    :key="index"
                    :class="['align-items-center', isSelected(row) ? 'selected' : '']"
                    @click="selectRow(row, 'detached')">
                    <td class="td-2" >
                      <span>{{ row.name }}</span>
                    </td>
                  </tr>
                  <tr v-if="attachedResellersList.length === 0" class="align-items-center">
                    <td class="no-content">Ainda não tem nenhuma loja atribuida.</td>
                  </tr>
                </tbody>
              </table>
              <div class="pagination__wrapper">
                <paginate
                  v-model="filters.attached.page"
                  :pageCount="attachTotal"
                  prevText="Anterior"
                  nextText="Próximo"
                  :click-handler="clickAttachCallback"
                  :containerClass="'pagination'">
                </paginate>
              </div>
            </d-col>
            <d-col cols="1" class="align-items-center col-1 d-flex justify-content-center position-relative">
              <d-button type="button" class="btn btn-outline-info btn-primary btn-sm" style="top: 100px" @click="sync">
                <i class="material-icons">sync_alt</i>
              </d-button>
            </d-col>
            <d-col class="col-table">
              <table class="table mb-0 table-striped">
                <thead class="bg-light">
                  <tr>
                    <th scope="col" class="border-0">Todas as lojas</th>
                  </tr>
                  <tr>
                    <td scope="col" class="border-0 px-0">
                      <div class="d-flex">
                        <select-state :model.sync="filters.deattach.state" class="col-3" :on-change="filterState"/>
                        <d-input v-model="filters.deattach.search" placeholder="Pesquisar" @change="filterSearch('deattach', $event)" class="form-control ml-md-3" />
                      </div>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in deattachedResellers" :key="index">
                    <td :class="['td-4', isSelected(row) ? 'selected' : '']" @click="selectRow(row, 'attached')">
                      <span>{{ row.name }}</span>
                    </td>
                  </tr>
                  <tr v-if="deattachedResellers.length === 0">
                    <td class="no-content">Ainda não tem nenhuma loja cadastrada.</td>
                  </tr>
                </tbody>
              </table>
              <div class="pagination__wrapper">
                <paginate
                  v-model="filters.deattach.page"
                  :pageCount="deattachTotal"
                  prevText="Anterior"
                  nextText="Próximo"
                  :click-handler="clickDeattachCallback"
                  :containerClass="'pagination'">
                </paginate>
              </div>
            </d-col>
          </d-row>
        </div>
      </d-form>
    </div>
    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="close()"
        class="btn btn-sm btn-secondary mr-4"
      >Cancelar</d-button>
      <d-button
        type="submit"
        @click="save"
        class="btn btn-sm btn-primary"
      >Salvar</d-button>
    </div>
  </modal-template>
</template>

<script>
import Events from '_utils/events';
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Paginate from 'vuejs-paginate';
import ModalTemplate from '_shared/Modal.vue';
import SelectState from '_shared/SelectState.vue';
import InputPhone from '_shared/InputPhone.vue';
import RepresentativeService from '_services/rest/modules/representative';
import { ATTACHED, DETACHED, MODEL, _EDIT_REPRESENTATIVE_ } from '../RepresentativeModel';

export default {
  name: 'representative-edit-modal',
  components: {
    Paginate,
    InputPhone,
    SelectState,
    ModalTemplate,
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      type: ATTACHED,
      timer: null,
      resellerSelected: [],
      filters: {
        attached: {
          search: null,
          page: 1,
        },
        deattach: {
          search: null,
          state: null,
          page: 1,
        },
      },
    };
  },
  computed: {
    title() {
      if (this.model.id) {
        return 'Editar Representante';
      }
      return 'Novo Representante';
    },
    states() {
      const { states } = this.$store.state.representative;
      if (states) {
        return states;
      }
      return [
        { value: null, label: '' },
      ];
    },
    attachTotal() {
      if (this.$store.state.representative.attachedResellers) {
        return Math.ceil(this.$store.state.representative.attachedResellers.length / 10);
      }
      return 0;
    },
    deattachTotal() {
      if (this.$store.state.representative.deattachedResellers) {
        return Math.ceil(this.$store.state.representative.deattachedResellers.length / 10);
      }
      return 0;
    },
    deattachedResellers() {
      const { deattachedResellers } = this.$store.state.representative;
      if (deattachedResellers) {
        const skip = (this.filters.deattach.page - 1) * 10;
        return deattachedResellers.slice(skip, skip + 10);
      }
      return [];
    },
    attachedResellersList() {
      const { attachedResellers } = this.$store.state.representative;
      if (attachedResellers) {
        const skip = (this.filters.attached.page - 1) * 10;
        if (this.filters.attached.search) {
          return attachedResellers.filter(reseller => (
            reseller.name ? reseller.name.toLowerCase().includes(this.filters.attached.search.toLowerCase()) : reseller
          ));
        }
        return attachedResellers.slice(skip, skip + 10);
      }
      return [];
    },
    attachedResellers() {
      const { attachedResellers } = this.$store.state.representative;
      if (attachedResellers) {
        return attachedResellers;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'setAttachedResellers',
      'getAttachedResellers',
      'syncAttacherResellers',
    ]),
    close() {
      this.model = cloneDeep(MODEL);
      this.setToggle({ type: 'edit_representative_modal', bool: false });
    },
    attach() {
      const attachArray = this.preparAttached();
      this.setAttachedResellers(attachArray);
      this.syncAttacherResellers({ attachedResellers: attachArray, representativeId: this.model.id })
        .then(this.saveSuccess)
        .catch(this.saveError);
    },
    detach() {
      this.setAttachedResellers(this.preparDetached());
      this.syncAttacherResellers({ attachedResellers: this.attachedResellers, representativeId: this.model.id })
        .then(this.saveSuccess)
        .catch(this.saveError);
    },
    filterState(state) {
      this.getAttachedResellers({ representativeId: this.model.id, group: DETACHED, state });
    },
    filterSearch(type = DETACHED, search) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.getAttachedResellers({
          search,
          group: type,
          state: this.filters[type].state,
          representativeId: this.model.id,
        });
      }, 800);
    },
    getResellers() {
      this.getAttachedResellers({ representativeId: this.model.id, group: DETACHED });
      this.getAttachedResellers({ representativeId: this.model.id, group: ATTACHED });
    },
    preparAttached() {
      return this.attachedResellers.concat(this.resellerSelected).map(row => row.id);
    },
    isSelected(row) {
      if (this.resellerSelected.includes(row)) {
        return true;
      }
      return false;
    },
    preparDetached() {
      return this.attachedResellers.filter(row => !this.resellerSelected.includes(row)).map(row => row.id);
    },
    saveError(error) {
      this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
    },
    saveSuccess() {
      this.resellerSelected = [];
      this.filters.attached = {
        page: 1,
        search: null,
      };
      this.filters.deattach = {
        page: 1,
        state: null,
        search: null,
      };
      this.model.count_resellers = this.$store.state.representative.attachedResellers.length;
      this.getResellers();
      this.activeAlert({ message: 'Sincronização salva com sucesso', theme: 'success' });
    },
    selectRow(row, type) {
      if (type !== this.type) {
        this.type = type;
        this.resellerSelected = [];
      }
      if (row.disabled) {
        return false;
      }
      const index = this.resellerSelected.indexOf(row);
      if (index > -1) {
        return this.resellerSelected.splice(index, 1);
      }
      return this.resellerSelected.push(row);
    },
    sync() {
      if (this.type === ATTACHED) {
        return this.attach();
      }
      return this.detach();
    },
    save() {
      const close = this.model.id !== null;
      RepresentativeService.save(this.model)
        .then(response => {
          this.model = response;
          Events.$emit('update:pagination', { page: 1 });
          if (close) {
            this.close();
          } else {
            this.getResellers();
          }
        });
    },
    clickAttachCallback(pageNum) {
      this.filters.attached.page = pageNum;
    },
    clickDeattachCallback(pageNum) {
      this.filters.deattach.page = pageNum;
    },
  },
  mounted() {
    Events.$on(_EDIT_REPRESENTATIVE_, representative => {
      this.model = representative;
      if (this.model.id) {
        this.getResellers();
      }
    });
  },
};
</script>

<style lang="scss">
@media (min-width: 992px) {
  .modal-lg {
    max-width: 1024px;
  }
}
</style>
<style lang="scss" scoped>
@import '~_scss/overrides';

.table {
  .no-content {
    vertical-align: middle;
  }
  .selected {
    background: lighten($cyan, 45%);
  }
  &-sync {
    tr td{
      height: 47px;
    }
  }
}

.pagination__wrapper {
  display: flex;
  justify-content: space-between;
  padding: 1rem 1rem 0;
  border-top: 1px solid #ddd;
  align-items: center;
  .pagination {
    display: flex;
    margin-bottom: 0;
    li {
      border: 1px solid $primary;
      margin-right: -1px;
      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
      &.disabled {
        // background: #d3d3d3;
        border: 1px solid #aaaaaa;
        a {
          color: #777;
          cursor: not-allowed;
        }
      }
      &.active {
        background: $primary;
        a {
          color: $card-cap-bg;
          cursor: default;
        }
      }
      a {
        padding: 6px 12px;
        display: block;
      }
    }
  }
}
</style>
